import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: ${props => `${props.maxWidth}px`};
  a {
    font-size: 0.65rem;
    line-height: 0.85rem;
  }
  @media (min-width: 768px) {
    a {
      transition: 250ms ease-out;
      &:hover {
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }
`

const Tags = ({ words, ...props }) => {
  const renderTags = () => {
    return words.map((word, i) => {
      return (
        <a
          key={i}
          href={`https://twitter.com/hashtag/${word}`}
          target="_blank"
          rel="noopener noreferrer"
          className="mouse-link"
        >
          #{word}&nbsp;
        </a>
      )
    })
  }
  return <Container {...props}> {renderTags()}</Container>
}

Tags.defaultProps = {
  words: ["teamgeek"],
  maxWidth: 800,
}

Tags.propTypes = {
  words: PropTypes.array,
  maxWidth: PropTypes.number,
}

export default Tags
